<template>
  <div class="portal-login-page">
    <header class="login-header">
      <div class="login-header-inner">
        <div class="login-brand" @click="goHome">
          <img :src="companyLogo" :alt="companyName">
          <div><strong>{{ companyName }}</strong><span>元器件一站式采购商城</span></div>
        </div>
        <i></i>
        <span>欢迎登录</span>
      </div>
    </header>

    <main class="login-main">
      <section class="login-card">
        <h1>手机验证码登录</h1>
        <label>
          <span>+86</span>
          <input v-model.trim="phone" maxlength="11" inputmode="numeric" placeholder="请输入手机号码" @keyup.enter="submit">
        </label>
        <label class="code-field">
          <input v-model.trim="verificationCode" maxlength="6" inputmode="numeric" placeholder="请输入短信验证码" @keyup.enter="submit">
          <button type="button" class="code-button" :disabled="sendingCode || countdown > 0" @click="sendCode">
            {{ countdown > 0 ? `${countdown}秒后重试` : (sendingCode ? '发送中...' : '获取验证码') }}
          </button>
        </label>
        <p>若手机号未注册，则视为注册账号</p>
        <button class="submit-button" :disabled="loading" @click="submit">{{ loading ? '登录中...' : '登录' }}</button>
      </section>
    </main>

    <footer>电子元器件一站式采购服务平台</footer>
  </div>
</template>

<script>
import { message } from 'ant-design-vue'
import { loginPcByPhone, sendPcLoginSmsCode } from '@/api/pc'
import pcAuth from '@/utils/pcAuth'
import { getPcMallSettings } from '@/api/pc'
import commerce from '@/utils/pcCommerce'

export default {
  name: 'PcLogin',
  data() {
    return {
      phone: '',
      verificationCode: '',
      loading: false,
      sendingCode: false,
      countdown: 0,
      countdownTimer: null,
      setting: {},
      logo: require('@/assets/logo.png')
    }
  },
  computed: {
    companyName() { return this.setting.companyName || '锐高科技' },
    companyLogo() { return this.setting.companyLogo ? commerce.normalizeAssetPath(this.setting.companyLogo) : this.logo }
  },
  created() {
    getPcMallSettings().then(data => { this.setting = data || {} }).catch(() => { this.setting = {} })
  },
  beforeDestroy() {
    this.clearCountdown()
  },
  methods: {
    goHome() {
      this.$router.push('/pc')
    },
    async sendCode() {
      if (!/^1[3-9]\d{9}$/.test(this.phone)) return message.warning('请输入正确的手机号码')
      if (this.sendingCode || this.countdown > 0) return
      this.sendingCode = true
      try {
        const result = await sendPcLoginSmsCode({ phone: this.phone })
        this.startCountdown(Number(result && result.retryAfterSeconds) || 60)
        message.success('验证码已发送')
      } catch (error) {
        message.error(error.message || '验证码发送失败，请稍后重试')
      } finally {
        this.sendingCode = false
      }
    },
    startCountdown(seconds) {
      this.clearCountdown()
      this.countdown = Math.max(1, Math.floor(seconds))
      this.countdownTimer = window.setInterval(() => {
        this.countdown -= 1
        if (this.countdown <= 0) this.clearCountdown()
      }, 1000)
    },
    clearCountdown() {
      if (this.countdownTimer) window.clearInterval(this.countdownTimer)
      this.countdownTimer = null
      if (this.countdown < 0) this.countdown = 0
    },
    async submit() {
      if (!/^1[3-9]\d{9}$/.test(this.phone)) return message.warning('请输入正确的手机号码')
      if (!/^\d{6}$/.test(this.verificationCode)) return message.warning('请输入6位短信验证码')
      if (this.loading) return
      this.loading = true
      try {
        const data = await loginPcByPhone({ phone: this.phone, verificationCode: this.verificationCode })
        pcAuth.saveLogin(data || {})
        message.success('登录成功')
        const redirect = String(this.$route.query.redirect || '/pc')
        this.$router.replace(redirect.startsWith('/pc') && redirect !== '/pc/login' ? redirect : '/pc')
      } catch (error) {
        message.error(error.message || '登录失败，请稍后重试')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.portal-login-page { min-width: 1200px; height: 100vh; overflow-y: auto; background: #fff; color: #27364a; font-family: Arial, "Microsoft YaHei", sans-serif; }
.login-header { height: 100px; background: #fff; }
.login-header-inner { width: 1200px; height: 100%; margin: 0 auto; display: flex; align-items: center; gap: 18px; }
.login-brand { display: flex; align-items: center; gap: 10px; cursor: pointer; }
.login-brand img { width: 58px; height: 58px; object-fit: contain; }
.login-brand strong, .login-brand span { display: block; }
.login-brand strong { color: #0b3b91; font-size: 25px; line-height: 29px; }
.login-brand span { margin-top: 2px; color: #6b7280; font-size: 11px; }
.login-header-inner > i { width: 1px; height: 44px; background: #d6dbe3; }
.login-header-inner > span { color: #64748b; font-size: 20px; }
.login-main { position: relative; min-height: calc(100vh - 150px); background: url('/login.jpg') center center / cover no-repeat; }
.login-card { position: absolute; top: 50%; right: calc(50% - 550px); width: 390px; padding: 38px 42px 42px; transform: translateY(-50%); border-radius: 14px; background: rgba(255, 255, 255, .96); box-shadow: 0 16px 42px rgba(36, 76, 125, .18); box-sizing: border-box; }
.login-card h1 { margin: 0 0 30px; padding-bottom: 14px; border-bottom: 2px solid #1684ff; color: #1f2937; font-size: 21px; font-weight: 500; text-align: center; }
.login-card label { height: 46px; display: flex; align-items: center; border: 1px solid #dce2ea; border-radius: 5px; background: #f7f8fa; overflow: hidden; box-sizing: border-box; }
.login-card .code-field { margin-top: 14px; }
.login-card label > span { width: 56px; border-right: 1px solid #dce2ea; color: #475569; text-align: center; }
.login-card input { min-width: 0; flex: 1; height: 100%; padding: 0 14px; border: 0; outline: 0; background: transparent; box-sizing: border-box; }
.code-button { height: 30px; margin-right: 8px; padding: 0 10px; border: 0; border-left: 1px solid #dce2ea; background: transparent; color: #1684ff; cursor: pointer; white-space: nowrap; }
.code-button:disabled { color: #94a3b8; cursor: not-allowed; }
.login-card p { margin: 10px 0 24px; color: #7b8798; font-size: 12px; }
.login-card .disabled-tip { margin: 4px 0 28px; font-size: 15px; line-height: 1.8; text-align: center; }
.submit-button { width: 100%; height: 44px; border: 0; border-radius: 5px; background: #1684ff; color: #fff; font-size: 16px; cursor: pointer; }
.submit-button:disabled { background: #8dbff5; cursor: wait; }
.portal-login-page > footer { height: 50px; display: flex; align-items: center; justify-content: center; color: #94a3b8; font-size: 12px; }
</style>
